import { render, staticRenderFns } from "./AttachmentAvatar.vue?vue&type=template&id=5f80e129&"
import script from "./AttachmentAvatar.vue?vue&type=script&lang=js&"
export * from "./AttachmentAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports